import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../../../components/landing/i18n/en.json';
import fr from '../../../components/landing/i18n/fr.json';

i18n
  .use(LanguageDetector) // Détecte automatiquement la langue du navigateur
  .use(initReactI18next) // Connecte à React
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: 'fr', // langue par défaut
    interpolation: {
      escapeValue: false, // React gère déjà l’échappement
    },
  });

export default i18n;
